import { render, staticRenderFns } from "./ProgrammeCopy.vue?vue&type=template&id=37ed9600&"
import script from "./ProgrammeCopy.vue?vue&type=script&lang=js&"
export * from "./ProgrammeCopy.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeCopy.vue?vue&type=style&index=0&id=37ed9600&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports